/* global localStorage */
import Vue      from 'vue';
import axios    from 'axios'
import store    from '@/store'

// Vue.use(axios)

let API_URL     = process.env.API_URL || 'http://localhost:3008/api/v1'

if (process.env.NODE_ENV === 'production') {
  console.log("App is in production Mode!");
  API_URL = "https://sportdb.freaks.technology/api/v1";
} else {
  console.log("App is in " + process.env.NODE_ENV + " Mode!");
  // API_URL = "http://localhost:3008/api/v1";
  API_URL = "http://austins-mac.local:3008/api/v1";
  // API_URL = "http://192.168.1.72:3008/api/v1";
  // API_URL = "http://172.20.10.2:3008/api/v1";
}



console.log("API-url: ", API_URL)

// export default axios.create({

let myAxios = axios.create({
  baseURL: API_URL,
  // withCredentials: true,
  headers: {
    'Authorization':                'Bearer ' + localStorage.token,
    'Content-Type':                 'application/json;charset=UTF-8',
    'Accept':                       'application/json;charset=UTF-8',
    "Access-Control-Allow-Origin":  '*'
  }
})

myAxios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log('API-ERROR!!! ', error);
    if(error.response){
      let status = error.response.status
      if (status === 401 || status === "401") {
        let text = "Fehler: "
        text += error.response.statusText
        text += " (Berchtigung fehlt / ist abgelaufen) - Bitte neu anmelden."
        store.dispatch('setMessage', {text: text, type: "error"})
        store.dispatch('logout')
      }
    }
    // return Promise.reject(error);
    return Promise.reject(error.response);
    
  }
)

export default myAxios